import { render } from "./Home.vue?vue&type=template&id=6a4f0152&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6a4f0152&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\v-tax-chauffeurs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4f0152"]])

export default __exports__